import { defineMessages, t } from '@sm/intl';

const COPY = defineMessages({
  SUCCESS_TOAST_ALL_SUBSCRIBED: {
    id: 'User.EmailPreferencesToast.SuccessToastAllSubscribed',
    defaultMessage: "You're now subscribed to all email categories.",
    description:
      '[Type: Paragraph][Vis.: med] - Marketing email preferences update success toast when all categories are subscribed',
  },
  SUCCESS_TOAST_ALL_UNSUBSCRIBED: {
    id: 'User.EmailPreferencesToast.SuccessToastAllUnsubscribed',
    defaultMessage: "You're now unsubscribed from all email categories.",
    description:
      '[Type: Paragraph][Vis.: med] - Marketing email preferences update success toast when all categories are unsubscribed',
  },
  SUCCESS_TOAST_MULTIPLE_CHANGED: {
    id: 'User.EmailPreferencesToast.SuccessToastMultipleChanged',
    defaultMessage: 'Your email preferences have been updated.',
    description:
      '[Type: Paragraph][Vis.: med] - Marketing email preferences update success toast when multiple categories changed',
  },
  SUCCESS_TOAST_CATEGORY_SUBSCRIBED: {
    id: 'User.EmailPreferencesToast.SuccessToastCategorySubscribed',
    defaultMessage: "You're now subscribed to {category}.",
    description:
      '[Type: Paragraph][Vis.: med] - Marketing email preferences update success toast when subscribed to a single category',
  },
  SUCCESS_TOAST_CATEGORY_UNSUBSCRIBED: {
    id: 'User.EmailPreferencesToast.SuccessToastCategoryUnsubscribed',
    defaultMessage: "You're now unsubscribed from {category}.",
    description:
      '[Type: Paragraph][Vis.: med] - Marketing email preferences update success toast when unsubscribed from a single category',
  },
  ERROR_TOAST_TITLE: {
    id: 'User.EmailPreferencesToast.ErrorToastTitle',
    defaultMessage: 'There was an error',
    description: '[Type: Paragraph][Vis.: med] - Marketing email preferences update error toast title',
  },
  ERROR_TOAST_BODY: {
    id: 'User.EmailPreferencesToast.ErrorToastBody',
    defaultMessage: 'Please try again',
    description: '[Type: Paragraph][Vis.: med] - Marketing email preferences update error toast body',
  },
});

export const SubscribeAll = () => ({
  title: t(COPY.SUCCESS_TOAST_ALL_SUBSCRIBED),
  dismissible: true,
});

export const UnsubscribeAll = () => ({
  title: t(COPY.SUCCESS_TOAST_ALL_UNSUBSCRIBED),
  dismissible: true,
});

export const MultipleChanged = () => ({
  title: t(COPY.SUCCESS_TOAST_MULTIPLE_CHANGED),
  dismissible: true,
});

export const SubscribedCategory = category => ({
  title: t(COPY.SUCCESS_TOAST_CATEGORY_SUBSCRIBED, { category }),
  dismissible: true,
});

export const UnsubscribedCategory = category => ({
  title: t(COPY.SUCCESS_TOAST_CATEGORY_UNSUBSCRIBED, { category }),
  dismissible: true,
});

export const GeneralError = () => ({
  color: 'warning',
  title: t(COPY.ERROR_TOAST_TITLE),
  body: t(COPY.ERROR_TOAST_BODY),
});
